import { OrderPreparationStatus, OrderProcessingStep, OrderStatus } from '@app/core/api-client/models';

export class CommandsHelper {
  private static commandStatus: CommandStatus[] = [
    {
      key: OrderStatus.Pending,
      transKey: 'COMMAND.STATUS.PENDING',
      descriptionTransKey: 'COMMAND.STATUS.PENDING_DESCRIPTION',
      icon: 'update',
      iconColor: 'order-icon-yellow',
    },
    {
      key: OrderStatus.WaitingPayment,
      transKey: 'COMMAND.STATUS.WAITINGPAYMENT',
      descriptionTransKey: 'COMMAND.STATUS.WAITINGPAYMENT_DESCRIPTION',
      icon: 'update',
      iconColor: 'order-icon-yellow',
    },
    {
      key: OrderStatus.PaymentSucceeded,
      transKey: 'COMMAND.STATUS.CONFIRMED',
      descriptionTransKey: 'COMMAND.STATUS.CONFIRMED_DESCRIPTION',
      icon: 'watch_later',
      iconColor: 'order-icon-green',
    },
    {
      key: OrderStatus.Validated,
      transKey: 'COMMAND.STATUS.CONFIRMED',
      descriptionTransKey: 'COMMAND.STATUS.CONFIRMED_DESCRIPTION',
      icon: 'watch_later',
      iconColor: 'order-icon-green',
    },
    {
      key: OrderStatus.Finalized,
      transKey: 'COMMAND.STATUS.DELIVRED',
      descriptionTransKey: 'COMMAND.STATUS.DELIVRED_DESCRIPTION',
      icon: 'check_circle',
      iconColor: 'order-icon-green',
    },
    {
      key: OrderStatus.Cancelled,
      transKey: 'COMMAND.STATUS.CANCELED',
      descriptionTransKey: 'COMMAND.STATUS.CANCELED_DESCRIPTION',
      icon: 'cancel',
      iconColor: 'order-icon-red',
    },
    {
      key: OrderStatus.Cancelled,
      transKey: 'COMMAND.STATUS.CANCELED',
      descriptionTransKey: 'COMMAND.STATUS.CANCELED_DESCRIPTION',
      icon: 'cancel',
      iconColor: 'order-icon-red',
    },
    // {
    //   key: OrderStatus.Undefined,
    //   transKey: 'COMMAND.STATUS.UNDEFINED',
    //   descriptionTransKey: 'COMMAND.STATUS.UNDEFINED_DESCRIPTION',
    //   icon: 'fiber_manual_record',
    //   iconColor: 'order-icon-red',
    // },
  ];

  public static getCommandStatutLabel(key: OrderStatus): CommandStatus {
    const status = this.commandStatus.find((x) => x.key === key);
    return status;
  }

  private static orderProcessingSteps: CommandStatus[] = [
    {
      key: OrderProcessingStep.PendingValidation,
      transKey: `COMMAND.ORDER_PREPARATION.PROCESSING_STEPS.${OrderProcessingStep.PendingValidation.toUpperCase()}`,
      descriptionTransKey: `COMMAND.ORDER_PREPARATION.PROCESSING_STEPS.${OrderProcessingStep.PendingValidation.toUpperCase()}_DESCRIPTION`,
      icon: 'update',
      iconColor: 'order-icon-yellow',
    },
    {
      key: OrderProcessingStep.PendingPreparation,
      transKey: `COMMAND.ORDER_PREPARATION.PROCESSING_STEPS.${OrderProcessingStep.PendingPreparation.toUpperCase()}`,
      descriptionTransKey: `COMMAND.ORDER_PREPARATION.PROCESSING_STEPS.${OrderProcessingStep.PendingPreparation.toUpperCase()}_DESCRIPTION`,
      icon: 'update',
      iconColor: 'order-icon-yellow',
    },
    {
      key: OrderProcessingStep.Processing,
      transKey: `COMMAND.ORDER_PREPARATION.PROCESSING_STEPS.${OrderProcessingStep.Processing.toUpperCase()}`,
      descriptionTransKey: `COMMAND.ORDER_PREPARATION.PROCESSING_STEPS.${OrderProcessingStep.Processing.toUpperCase()}_DESCRIPTION`,
      icon: 'watch_later',
      iconColor: 'order-icon-green',
    },
    {
      key: OrderProcessingStep.Processed,
      transKey: `COMMAND.ORDER_PREPARATION.PROCESSING_STEPS.${OrderProcessingStep.Processed.toUpperCase()}`,
      descriptionTransKey: `COMMAND.ORDER_PREPARATION.PROCESSING_STEPS.${OrderProcessingStep.Processed.toUpperCase()}_DESCRIPTION`,
      icon: 'beenhere',
      iconColor: 'order-icon-green',
    },
    {
      key: OrderProcessingStep.Finalized,
      transKey: `COMMAND.ORDER_PREPARATION.PROCESSING_STEPS.${OrderProcessingStep.Finalized.toUpperCase()}`,
      descriptionTransKey: `COMMAND.ORDER_PREPARATION.PROCESSING_STEPS.${OrderProcessingStep.Finalized.toUpperCase()}_DESCRIPTION`,
      icon: 'check_circle',
      iconColor: 'order-icon-green',
    },
    {
      key: OrderProcessingStep.Cancelled,
      transKey: `COMMAND.ORDER_PREPARATION.PROCESSING_STEPS.${OrderProcessingStep.Cancelled.toUpperCase()}`,
      descriptionTransKey: `COMMAND.ORDER_PREPARATION.PROCESSING_STEPS.${OrderProcessingStep.Cancelled.toUpperCase()}_DESCRIPTION`,
      icon: 'cancel',
      iconColor: 'order-icon-red',
    }
  ];

  public static getOrderProcessingStep(key: OrderProcessingStep): CommandStatus {
    const status = this.orderProcessingSteps.find((x) => x.key === key);
    return status;
  }
}

export interface CommandStatus {
  key: string;
  transKey: string;
  descriptionTransKey: string;
  icon: string;
  iconColor: string;
}
